import React, { Fragment } from "react";
import useExtras from "../../../../hooks/shared/extras/useExtras";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import { useBnbSelector } from "../../../../redux/store";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/Popover";
import type { ExtraType } from "../../../../../../../common-deprecated/types/CommonTypes";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as PacksView from "./styles/Packs";
import CategorizedExtras from "../../common/extras/CategorizedExtras";
import ExtraFilter from "./ExtraFilter";
import { isMasterOrSlave } from "../../../../../../../common-deprecated/settings/utils/commonSettingUtils";

const Extras = (): JSX.Element => {
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const basketExtras = useBnbSelector((state) => state.basket.extras);

    const wltpPopupText = useBnbOptionalLabel("T1.disclaimerWltpShort");
    const showSearch = !isMasterOrSlave(commonSettings);

    const extrasProps = useExtras();
    const { hasActiveFilters, categorizedExtras, onAddExtra, onRemoveExtra, onSetExtraOption } = extrasProps;
    const totalExtras = categorizedExtras.reduce((acc: ExtraType[], category) => acc.concat(category.extras), []);
    const extrasDisclaimerLabel = useBnbOptionalLabel("allExtrasDisclaimer");

    // No filters configured and no extras to be shown.
    if (!hasActiveFilters && totalExtras.length === 0) return <BnbLabel label="noExtras" />;

    return (
        <>
            {showSearch && <ExtraFilter />}
            {totalExtras.length > 0 ? (
                <>
                    <PacksView.Header>
                        <Flex.Col width={{ sm: 7 / 12, md: 1 }}>
                            <Type.H2 headingType="gamma">
                                <BnbLabel label="allExtras" />
                                {!!wltpPopupText && <Popover showOnClick content={wltpPopupText} useHTML />}
                            </Type.H2>
                            <Type.Text my={3}>
                                <BnbLabel label="allExtrasLead" />
                                {!!extrasDisclaimerLabel && <Type.H5 my={3}>{extrasDisclaimerLabel}</Type.H5>}
                            </Type.Text>
                        </Flex.Col>
                    </PacksView.Header>
                    {categorizedExtras.map((categorizedExtra) => (
                        <Fragment key={categorizedExtra.id}>
                            <CategorizedExtras
                                categorizedExtra={categorizedExtra}
                                onAddExtra={onAddExtra}
                                onRemoveExtra={onRemoveExtra}
                                onSetExtraOption={onSetExtraOption}
                                basketExtras={basketExtras}
                                disableBuildAccessories={!!bnbSettings.disableBuildAccessories}
                            />
                        </Fragment>
                    ))}
                </>
            ) : (
                <Flex.Col px={0} py={4}>
                    <Type.H2 mb={4}>
                        <BnbLabel label="noExtrasFoundHeader" />
                    </Type.H2>
                    <Type.Text>
                        <BnbLabel label="noExtrasFound" />
                    </Type.Text>
                </Flex.Col>
            )}
        </>
    );
};

export default Extras;
